import { Helmet } from 'react-helmet';

import ShareIcon from '@/assets/all-icons/share-icon';
import useGoBack from '@/hooks/useGoBack';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import ViewsIcon from "@/shared-components/icons/components/user-profile/ViewsIcon";
import {
  buildLocalizedAlternateUrls,
  resolveCurrentPathLocale,
  resolveLocalizedCanonicalUrl,
} from '@/utils/localePublicUrl';

import './styles/PostNotFound.css';

export default function PostNotFound({ mode = 'post' }) {
  const goBackHandler = useGoBack("/");
  const label = mode === 'article' ? 'Article' : 'Post';
  const resolvedLocale = resolveCurrentPathLocale();
  const resolvedCanonicalUrl = resolveLocalizedCanonicalUrl({ canonicalPath: "/", locale: resolvedLocale });
  const alternateUrls = buildLocalizedAlternateUrls({ canonicalPath: "/", locale: resolvedLocale });

  return (
    <>
      <Helmet>
        <html lang={resolvedLocale} />
        <title>{label} Not Found | Suarte</title>
        <meta name="description" content={`This ${mode} is not available on Suarte.`} />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="googlebot" content="noindex,nofollow" />
        <link rel="canonical" href={resolvedCanonicalUrl} />
        {alternateUrls.map((alternate) => (
          <link key={alternate.hrefLang} rel="alternate" hrefLang={alternate.hrefLang} href={alternate.href} />
        ))}
      </Helmet>
      <div className="post-not-found__container">
        <div className="post-not-found__header">
          <BackArrowIcon className="post-not-found__go-back" onClick={goBackHandler}/>
          <ShareIcon className="post-not-found__share-icon"/>
        </div>

        <div className="post-not-found__main">
          <div className="post-not-found__cover"/>

          <div className="post-not-found__content">
            <h1 className="post-not-found__title">
              {label} not found
            </h1>

            <div className="post-not-found__info">
              <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                <div className="post-not-found__text" style={{ width: "25%", minWidth: "74px" }}/>
                <div className="post-not-found__separator"/>
                <div className="post-not-found__text" style={{ width: "25%", minWidth: "74px" }}/>
              </div>

              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="post-not-found__text" style={{ width: "40px" }}/>
                <ViewsIcon className="post-not-found__view-icon"/>
              </div>
            </div>

            <div className="post-not-found__text" style={{ marginBottom: "10px" }}/>
            <div className="post-not-found__text" style={{ marginBottom: "10px" }}/>
            <div className="post-not-found__text" style={{ marginBottom: "10px" }}/>
            <div className="post-not-found__text" style={{ marginBottom: "10px" }}/>
            <div className="post-not-found__text" style={{ marginBottom: "10px" }}/>
            <div className="post-not-found__text" style={{ width: "40%" }}/>
          </div>
        </div>
      </div>
    </>
  );
}
